"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.defaultLogQueue = exports.JsonLogQueue = void 0;
var event_1 = require("./event");
var frameStart_1 = require("../metadata/frameStart");
var logger_1 = require("../logger");
var transmit_1 = require("../network/transmit");
var log = (0, logger_1.getLogger)("queue");
var JsonLogQueue = (function () {
    function JsonLogQueue(logQueueName) {
        this.sequenceId = 1;
        this.logQueueName = logQueueName;
    }
    JsonLogQueue.prototype.append = function (item) {
        if ((0, frameStart_1.isFrameStart)(item)) {
            log.trace("Saw new FrameStart, copying for this queue");
            this.lastFrameStart = __assign(__assign({}, item), { log_queue_name: this.logQueueName });
        }
        else if ((0, event_1.isEvent)(item)) {
            if (this.lastFrameStart === undefined) {
                throw new Error("Event before FrameStart");
            }
            var event_2 = __assign(__assign(__assign(__assign({}, item.data), item.metadata), this.lastFrameStart), { log_queue_sequence_id: this.sequenceId++ });
            (0, transmit_1.transmitJsonEvents)([event_2]);
        }
        else {
            throw new Error("Illegal item: " + item);
        }
    };
    return JsonLogQueue;
}());
exports.JsonLogQueue = JsonLogQueue;
exports.defaultLogQueue = new JsonLogQueue("w");
//# sourceMappingURL=queue.js.map